const baseUrl = process.env.REACT_APP_APIEND;
const baseUrlcx = process.env.REACT_APP_APICX;

/**
 * Hace una petición a la API sin token
 *
 * @param {string} endpoint - Endpoint de la API
 * @param {object} data - Datos a enviar
 * @param {string} method - Método de la petición
 * @returns {Promise<object>} - Respuesta de la API
 */
export const fetchWithoutToken = async (endpoint, data, method) => {
  const url = `${baseUrl}/${endpoint}`;

  if (method === "GET") {
    const resp = await fetch(url);
    return await resp.json();
  } else {
    const resp = await fetch(url, {
      method,
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    });

    return await resp.json();
  }
};

/**
 * Hace una petición a la API con token
 *
 * @param {string} endpoint - Endpoint de la API
 * @param {object} data - Datos a enviar
 * @param {string} method - Método de la petición
 * @returns {Promise<object>} - Respuesta de la API
 */
export const fetchWithToken = async (endpoint, data, method = "GET") => {
  try {
    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem("token") || "";

    if (method === "GET") {
      const resp = await fetch(url, {
        headers: {
          "x-token": token,
        },
      });
      return await resp.json();
    } else {
      const resp = await fetch(url, {
        method,
        headers: {
          "Content-type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(data),
      });

      return await resp.json();
    }
  } catch (error) {
    return { ok: false, error };
  }
};
export const fetchWithCX = async (endpoint, data, method = "GET") => {
  try {
    const url = `${baseUrlcx}/${endpoint}`;
    const token =
      "$2a$10$GITJGYJtKCrFCyK6MaFmG.AnMrPhpqB7O0JtJANzW9TjEwi7nskPm";
    if (method === "GET") {
      const resp = await fetch(url, {
        headers: {
          "cx-token": token,
        },
      });
      return await resp.json();
    } else {
      const resp = await fetch(url, {
        method,
        headers: {
          "Content-type": "application/json",
          "cx-token": token,
        },
        body: JSON.stringify(data),
      });

      return await resp.json();
    }
  } catch (error) {
    return { ok: false, error };
  }
};

/**
 * Sube un archivo a la API
 *
 * @param {FormData} bodyContent - Contenido del archivo
 * @param {string} endpoint - Endpoint de la API
 * @param {string} method - Método de la petición
 * @returns {Promise<object>} - Respuesta de la API
 */
export const uploadFile = async (bodyContent, endpoint, method = "PUT") => {
  const token = localStorage.getItem("token") || "";

  const url = `${baseUrl}/${endpoint}`;
  try {
    let headersList = {
      Accept: "*/*",
      "x-token": token,
    };
    let response = await fetch(`${url}`, {
      method,
      body: bodyContent,
      headers: headersList,
    });
    return await response.json();
  } catch (error) {
    return { ok: false, error };
  }
};
